// @ts-nocheck

import { matchPath } from 'react-router-dom';

import { RoutePatterns } from '../types/routes';
import { type AnyObject } from '../types/utils';

type PathMatchingOptions =
  | AnyObject
  | {
      exact?: boolean;
    };

const isPathMatching = (pathname: string, pattern: string, options?: PathMatchingOptions) =>
  !!matchPath(pathname, { path: pattern, ...options });

const isHome = (pathname: string, options?: PathMatchingOptions = { exact: true }) =>
  isPathMatching(pathname, RoutePatterns.HOME, options);

const isSports = (pathname: string, options?: PathMatchingOptions = { exact: true }) =>
  isPathMatching(pathname, RoutePatterns.SPORTS, options);

const isCatalog = (pathname: string, options?: PathMatchingOptions = { exact: true }) =>
  isPathMatching(pathname, RoutePatterns.CATALOG, options);

const isLive = (pathname: string, options?: PathMatchingOptions = { exact: true }) =>
  isPathMatching(pathname, RoutePatterns.LIVE, options);

const isHistory = (pathname: string, options?: PathMatchingOptions = { exact: true }) =>
  isPathMatching(pathname, RoutePatterns.HISTORY, options);

const isSportsSubMenu = (pathname: string, options?: PathMatchingOptions = { exact: true }) => {
  const match = matchPath(pathname, { path: RoutePatterns.SPORTS, ...options });
  const sportId = match?.params?.sportId;

  return isSports(pathname) && sportId !== null && sportId !== undefined;
};

const Main = {
  isHome,
  isSports,
  isSportsSubMenu,
  isCatalog,
  isLive,
  isHistory,
};

const isExtras = (pathname: string, options?: PathMatchingOptions = { exact: true }) =>
  isPathMatching(pathname, RoutePatterns.EXTRAS, options);

const Extras = {
  isExtras,
};

const isGrids = (pathname: string, options?: PathMatchingOptions = { exact: true }) =>
  isPathMatching(pathname, RoutePatterns.GRIDS, options) ||
  // check if path is /grilles/:poolTitle but not /grilles/history
  (isPathMatching(pathname, RoutePatterns.POOL, options) &&
    !isPathMatching(pathname, RoutePatterns.GRID_HISTORY, options));

const isGridsHistory = (pathname: string, options?: PathMatchingOptions = { exact: true }) =>
  isPathMatching(pathname, RoutePatterns.GRID_HISTORY, options);

const Grids = {
  isGrids,
  isGridsHistory,
};

const isKL = (pathname: string, options?: PathMatchingOptions = { exact: true }) =>
  isPathMatching(pathname, RoutePatterns.KL, options);

const KL = {
  isKL,
};

const isGR = (pathname: string, options?: PathMatchingOptions = { exact: true }) =>
  isPathMatching(pathname, RoutePatterns.GR, options);

const isGREnrollment = (pathname: string, options?: PathMatchingOptions = { exact: true }) =>
  isPathMatching(pathname, RoutePatterns.GR_ENROLLMENT, options);

const GR = {
  isGR,
  isGREnrollment,
};

const isMonopoly = (pathname: string, options?: PathMatchingOptions = { exact: true }) =>
  isPathMatching(pathname, RoutePatterns.MP, options);

const MP = {
  isMonopoly,
};

const isBoom = (pathname: string, options?: PathMatchingOptions = { exact: true }) =>
  isPathMatching(pathname, RoutePatterns.BOOM, options);

const BOOM = {
  isBoom,
};

const Modules = {
  ...Extras,
  ...Grids,
  ...KL,
  ...GR,
  ...MP,
  ...BOOM,
};

const Routes = {
  ...Main,
  ...Modules,
};

export default Routes;
